import { jwtDecode } from 'jwt-decode';
import { getCookie } from 'cookies-next';
import { USER_ID } from 'src/constants/registration';
import { findLocalItems } from './localStorageActions';
import { TokenPayload } from 'src/interfaces/auth';

export const getUserId = () => {
  const token = findLocalItems();
  const decoded: TokenPayload | null = token ? jwtDecode(token) : null;
  return (decoded && decoded['custom:id']) || localStorage.getItem(USER_ID) || getCookie(USER_ID);
};
